<template>
  <div>
    <colored-popup :class="categoryToVariant[selectedCategory.cashflowCategory]" :close-action="close">

      <template v-slot:top-content>
        <transaction-details :transaction="transaction"/>
      </template>

      <template v-slot:bottom-content>
        <text-input :value="slices" :autofocus="true" :on-input="onInput"/>
        <cashflow-category-dropdown :options="availableCategories" :first-selected="selectedCategory"
                                    :on-select="onSelection"/>
        <riseup-button :action="onSave" :variant="'primary'" :title="'אישור'" :disabled="isSaveDisabled"/>
      </template>

    </colored-popup>
  </div>
</template>

<script>
import _ from 'lodash';
import { v1 as uuidv1 } from 'uuid';
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import TransactionDetails from './TransactionDetails.vue';
import Segment from '../../../../../../../../../../Segment';

export default {
  name: 'SplitTransaction',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    TextInput: BaseUI.TextInput,
    TransactionDetails,
    RiseupButton: BaseUI.RiseupButton,
    CashflowCategoryDropdown: BaseUI.CashflowCategoryDropdown,
  },
  created() {
    this.splitTransactions = _.filter(this.transactionsInCurrentCashflow, { splitFrom: this.transaction.splitFrom });

    if (this.splitTransactions) {
      this.actionType = 'update';
      this.slices = _.chain(this.splitTransactions).map('billingAmount').join().value();
    } else {
      this.actionType = 'create';
    }

    this.sendSegmentEvent('SplitTransaction_Shown');
  },
  data() {
    return {
      slices: '',
    };
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', ['selectedCategory', 'categoryToVariant', 'availableCategories']),
    ...mapGetters('cashflowView', ['transactionsInCurrentCashflow']),
    isSaveDisabled() {
      return false;
    },
    category() {
      return this.selectedCategory;
    },
  },
  methods: {
    ...mapActions('editCashflow', ['splitTransaction']),
    close() {
      this.sendSegmentEvent('SplitTransaction_CloseClicked');
      this.$emit('close');
    },
    sendSegmentEvent(eventName) {
      Segment.trackUserInteraction(eventName, {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
        transactionId: this.transaction.transactionId,
      });
    },
    async onSave() {
      this.sendSegmentEvent('SplitTransaction_SaveClicked');
      const splitTransactionIds = _.map(this.splitTransactions, 'transactionId');
      const slicesAmount = this.slices.split(',');
      const categoryId = this.selectedCategory.categoryId ? this.selectedCategory.categoryId : this.selectedCategory.categoryName;
      const slices = _.zipWith(splitTransactionIds, slicesAmount, (transactionId, amount) => {
        return { transactionId: transactionId || uuidv1(), amount: amount || 0, categoryId };
      });
      await this.splitTransaction({ transactionId: this.transaction.transactionId, actionType: this.actionType, slices });
      this.$emit('close');
    },
    onInput(slices) {
      this.slices = slices;
    },
    onSelection(category) {
      this.category = category;
    },
  },
};
</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.change-transaction-category-popup {
  text-align: right;

  .riseup-button {
    width: 100%;
  }
}

</style>
